import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certboxActions } from '../../../../store/actions'

const CertRecvBox = (props) => {
  const [state, setState] = useState({
    recvId: '',
    recvName: '',
    recvMulti: '',
  })
  
  const [addMulti, setAddMulti] = useState([])

  const [walletList, setWalletList] = useState([])

  useEffect(() => {
    return () => {
      // 페이지 다른 곳으로 이동시 이전 정보들 초기화
      onClose()
    }
  }, [])

  useEffect(() => {
    if (state.isOpen) {
      if (state.subject === 'Recent') {
        // 최근 보낸주소 호출
        props.getRecentReceiver()
      }
    } else {
      // 리스트 초기화
      props.resetWalletList()
    }
  }, [state.isOpen])

  useEffect(() => {
    setState({
      ...state,
      isOpen: props.target?.type,
      subject: props.target?.subject,
    })
  }, [props.target])

  useEffect(() => {
    setWalletList(props.walletList)
  }, [props.walletList])

  useEffect(() => {
    if (props.walletName !== '' && props.walletName !== undefined) {
      setState({
        ...state,
        recvName: props.walletName ? props.walletName : '존재하지 않는 지갑주소',
      })
    }
  }, [props.walletName])

  const onClose = () => {
    const popInfo = {
      type: false,
      subject: '',
    }

    props.openReceiverBox(popInfo)

    // 기존 검색어도 다 초기화
    setState({
      ...state,
      recvId: '',
      recvName: '',
      walletText: '',
    })

    setAddMulti([])
  }

  const getReceiverInfo = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })

    props.searchWalletName(value)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleCheck = (e) => {
    const { checked, value } = e.target
    let newMulti = null

    if (checked) {
      newMulti = addMulti.concat(value)
    } else {
      // 체크해제
      newMulti = addMulti.filter((target) => target !== value)
    }

    setAddMulti(newMulti)
  }

  const sendReceiverList = () => {
    if (!props.walletName) {
      // 존재하지 않는 지갑주소일 경우에 추가하지 않음
      props.error({
        title: '추가불가',
        message: '존재하지 않는 지갑주소 입니다.',
      })

      onClose()
    } else {
      const obj = {
        ewalletId: state.recvId,
        name: state.recvName,
      }

      props.addReceiverInfo([obj])

      // 초기화
      setState({
        ...state,
        isOpen: false,
        recvId: '',
        recvName: '',
      })
    }
  }

  const sendMultiReceiverList = (Type) => {
    let list = []

    if (Type === 'RECENT') {
      addMulti.forEach((target) =>
        props.receiverList?.map((receiver) => {
          if (receiver.ewalletId === target) {
            list.push({
              ewalletId: receiver.ewalletId,
              name: receiver.name,
            })
          }
        }),
      )
    } else if (Type === 'SEARCH') {
      // 선택한 주소들 넣고 기존 검색 정보 초기화
      addMulti.forEach((target) =>
        walletList?.map((wallet) => {
          if (wallet.ewalletId === target) {
            list.push({
              ewalletId: wallet.ewalletId,
              name: wallet.name,
            })
          }
        }),
      )

      setWalletList([])
    }

    props.addReceiverInfo(list)

    setState({
      ...state,
      isOpen: false,
      walletText: '',
    })

    setAddMulti([]) // 초기화
  }

  // 전자지갑주소 검색
  const onSearch = () => {
    const { walletText } = state

    props.searchWalletAddr({ keyword: walletText })
  }

  return (
    <>
      {state.isOpen ? (
        <div className="modal-overlay normal modal-certificate">
          <div className="modal">
            <div className="modal-content">
              {state.subject === 'Search' && (
                <div className="">
                  <div className="modal-header">
                    전자지갑주소 검색
                    <button
                      type="button"
                      className="icon-close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => onClose()}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="flex-sb input-sch">
                      <input
                        title="찾기"
                        type="text"
                        name="walletText"
                        placeholder="법인명 또는 이름"
                        value={state.walletText}
                        onChange={(e) => handleChange(e)}
                      />
                      <button className="btn " onClick={onSearch}>
                        찾기
                      </button>
                    </div>
                    <div className="address-list m0">
                      {walletList?.length > 0 ? (
                        walletList?.map((info, index) => (
                          <div key={index} className="flex-row">
                            <input
                              title="전자지갑주소"
                              type="checkbox"
                              name="walletList"
                              value={info.ewalletId}
                              onChange={handleCheck}
                            />
                            {info.name}
                          </div>
                        ))
                      ) : (
                        <div className="noData">해당 정보가 존재하지 않습니다.</div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-white" onClick={() => sendMultiReceiverList('SEARCH')}>
                      확인
                    </button>
                  </div>
                </div>
              )}

              {state.subject === 'Recent' && (
                <div className="">
                  <div className="modal-header">
                    최근보낸주소
                    <button
                      type="button"
                      className="icon-close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => onClose()}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="address-list m0">
                      {props.receiverList.length > 0 ? (
                        props.receiverList?.map((info, index) => (
                          <div key={index} className="flex-row">
                            <input
                              title="전자지갑주소"
                              type="checkbox"
                              name="recvMulti"
                              value={info.ewalletId}
                              onChange={handleCheck}
                            />
                            {info.name}
                          </div>
                        ))
                      ) : (
                        <div className="flex-row">해당 정보가 존재하지 않습니다.</div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-white" onClick={() => sendMultiReceiverList('RECENT')}>
                      확인
                    </button>
                  </div>
                </div>
              )}

              {state.subject === 'Paste' && (
                <div className="">
                  <div className="modal-header">
                    지갑주소 붙여넣기
                    <button
                      type="button"
                      className="icon-close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => onClose()}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <input
                      title="전자지갑주소"
                      type="text"
                      name="recvId"
                      placeholder="지갑주소"
                      className="form-control m-b-10"
                      value={state.recvId}
                      onChange={(e) => getReceiverInfo(e)}
                    />

                    <input
                      title="사용자명"
                      type="text"
                      name="recvName"
                      placeholder="이름"
                      className="form-control"
                      value={state.recvName}
                      readOnly
                    />
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-white" onClick={sendReceiverList}>
                      확인
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    target: state.certbox?.target,
    receiverList: state.certbox?.receiverList,
    walletList: state.certbox?.walletList,
    walletName: state.certbox?.walletName,
  }
}

const actionCreators = {
  openReceiverBox: certboxActions.openReceiverBox,
  addReceiverInfo: certboxActions.addReceiverInfo,
  getRecentReceiver: certboxActions.getRecentReceiver,
  searchWalletAddr: certboxActions.getWalletAddr,
  searchWalletName: certboxActions.getWalletName,
  resetWalletList: certboxActions.resetWalletList,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertRecvBox)
